import { render } from "./SiderMenu.vue?vue&type=template&id=ca7f5912"
import script from "./SiderMenu.vue?vue&type=script&lang=js"
export * from "./SiderMenu.vue?vue&type=script&lang=js"

import "./SiderMenu.vue?vue&type=style&index=0&id=ca7f5912&lang=scss"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__